import { analyticsLogEvent } from '@src/utils/analytics';

export const reportAnalyticsEvents = {
  eventClickAuJbankReport: () => analyticsLogEvent({ category: '【click】資産収支_資産タブ', action: 'auじぶん銀行(金額タップ)' }),
  eventClickAuStockReport: () => analyticsLogEvent({ category: '【click】資産収支_資産タブ', action: 'auカブコム証券(金額タップ)' }),
  eventClickAuPayReport: () => analyticsLogEvent({ category: '【click】資産収支_資産タブ', action: 'au PAY(金額タップ)' }),
  eventClickAssetReport: () => analyticsLogEvent({ category: '【click】資産収支_資産タブ', action: '資産タブ' }),
  eventClickBalanceReport: () => analyticsLogEvent({ category: '【click】資産収支_資産タブ', action: '収支タブ' })
};
